<template>
  <div class="creations-box d-flex flex-column" :class="{ 'pt-0 pr-0 pl-0': creatorStudio.isMobile }">
    <p v-if="completedJobs.length === 0" class="p-3 d-flex"><span class="alert alert-info">{{ 'Nothing created yet' | trans }}</span></p>
    <div v-if="completedJobs.length > 0" v-for="completedJob in completedJobs" :key="completedJob.uuid" class="job-item d-flex flex-column p-20"
        >
      <div class="d-flex gap-10 flex-column">
        <div class="d-flex gap-10 justify-content-between align-items-center">
          <div class="d-flex gap-10">
            <div class="grey-box d-flex align-items-center pl-0">
              <img
                  :alt="getStyleName(completedJob)"
                  :srcset="getStyleSrcset(completedJob)"
                  @click="openTab(completedJob)"
              />
              <div class="font-weight-bold cursor-pointer" @click="openTab(completedJob)"> {{ getStyleName(completedJob) }}</div>
            </div>
            <div class="grey-box d-flex align-items-center cursor-pointer">
              <div class="font-weight-bold" @click="openTab(completedJob)">{{ getRatio(completedJob) }}</div>
            </div>
          </div>
          <div class="remove-job-item cursor-pointer" @click="remove(completedJob.id)">
            <i class="far fa-trash-alt lh-inherit" ></i> {{ 'Remove' | trans }}
          </div>
        </div>
        <div>
          <div class="prompt-info cursor-pointer" @click="openTab(completedJob)">
            <div><strong>{{ 'Prompt' | trans }}</strong></div>
            <span>{{ completedJob.settings.prompt }}</span>
            <span v-if="completedJob.settings.activeTool === 'similiarimage'" class="font-italic">{{ 'Similiar Image' | trans }}</span>
          </div>
        </div>
      </div>
      <div class="job-result cursor-pointer" @click="openTab(completedJob)">
        <div class="d-flex image" v-for="image in completedJob.base64_output_images">
          <img :src="image"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from './../../mixins/store.mixin';
import currentJob from './../../mixins/current_job.mixin';
import StylesManager from "../../manager/StylesManager";
import StudioManager from '../../manager/StudioManager';

export default {
  name: "Creations",
  mixins: [store, currentJob],
  methods: {
    getStyleName(completedJob) {
      return StylesManager.getStyleByName(completedJob.settings.conversion.options.style).name;
    },
    getStyleSrcset(completedJob) {
      const sidebar = StylesManager.getStyleByName(completedJob.settings.conversion.options.style).path.sidebar;
      return `${sidebar['1x']} 1x,  ${sidebar['2x']} 2x, ${sidebar['3x']} 3x,  ${sidebar['4x']} 4x`;
    },
    getRatio(completedJob) {
      return completedJob.settings.conversion.options.aspect_ratio;
    },
    openTab(completedJob) {
      completedJob.isOpen = true;
      StudioManager.openJob(completedJob.id);

      if (this.creatorStudio.isMobile && this.$parent.$refs.galleryMobile) {
        this.$parent.$refs.galleryMobile.scrollIntoView({behavior: 'smooth'});
      }
    },
    remove(id) {
      if (id === this.currentJob.id) {
        this.creatorStudio.jobs = this.creatorStudio.jobs.filter(job => job.id !== id);
        const jobsLength = this.creatorStudio.jobs.length;
        if (jobsLength > 1) {
          StudioManager.openJob(this.creatorStudio.jobs[0]?.id, null, true);
        } else {
          StudioManager.openWelcomeJob();
        }
      }else{
        this.creatorStudio.jobs = this.creatorStudio.jobs.filter(job => job.id !== id);
      }

    }
  },
  computed: {
    completedJobs() {
      return this.creatorStudio.jobs.filter(job => job.state === 'completed').reverse();
    },
  },
};
</script>

<style lang="scss">
.creations-box {
  color: white;
  display: flex;
  flex-direction: column;


  .prompt-info {
    border: 1px solid #343434;
    background: #383838;
    border-radius: 4px;
    display: inline-flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;
  }

  p {
    padding: 0px 20px;
  }
}

.job-item {
  gap: 10px;
  border-bottom: 1px solid #595959;

  &:hover {
    background: #323232;
  }


}

.remove-job-item {
  display: flex;
  padding: 10px 20px;
  gap: 10px;
  border-radius: 4px;

  &:hover {
    background: #383838;

    .fa-trash-alt {
      color: red;
    }
  }
}

.grey-box {
  padding: 0px 10px;
  height: 30px;
  gap: 10px;
  border-radius: 3px;
  background: #383838;

  img {
    height: 30px;
    width: 30px;
  }
}

.prompt {
  padding: 10px;
  border-radius: 3px;
  background: #383838;
}

.job-result {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .image {
    height: 81px;
    box-shadow: 10px 10px 10px 0px rgba(0, 0, 0, 0.25);

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: 3px;
    }
  }
}
</style>
